export interface PromotionInfo extends PromotionCampaignProps {
  campaignCode: string,
  discountPercentage: number,
}

export interface PromotionCampaignProps{
  endDate: Date,
  priceConfig?: PromotionPriceProps,
  bannerConfig?: PromotionBannerProps,
}

export interface PromotionPriceProps {
  currentPrice?: number,
  discountPrice?: number,
  priceUnit?: string,
}

export interface PromotionBannerProps {
  bannerStyle?: Map<string, string>,
  promotionPrefix: PromotionCampaignPrefix,
  hidePromotionPrice?: boolean,
}

export enum PromotionCampaignPrefix {
  DEFAULT = 'DEFAULT',
  HOLIDAYPROMO = 'HOLIDAYPROMO',
  NEWYEAR2025 = 'NEWYEAR2025',
}

export enum PromoBannerComponentName {
  LEFT_BACKGROUND = 'LEFT_BACKGROUND',
  HOUR_GLASS = 'HOUR_GLASS',
}
